import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { SubscriptionPlanInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialPlan: Partial<SubscriptionPlanInterface> = {
  planName: '',
  description: '',
  price: 0,
  active: true,
};

const AdSpaceSubscriptionPlansAdminAddSubscriptionPlanPage: React.FC = () => {
  const [plan, setPlan] = useState<Partial<SubscriptionPlanInterface>>(initialPlan);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof SubscriptionPlanInterface, value: any) => {
    setPlan(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<SubscriptionPlanInterface>>('/subscriptionPlans/insert', 'POST', plan);
      if (result.status) {
        setSuccess(result.message || 'Subscription plan created successfully!');
        setDialogOpen(true);
        setPlan(initialPlan);
      } else {
        setError(result.message || 'Failed to create subscription plan');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create subscription plan');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Subscription Plan</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Plan Name"
          value={plan.planName ?? ''}
          onChange={e => handleChange('planName', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Description"
          value={plan.description ?? ''}
          onChange={e => handleChange('description', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Price"
          type="number"
          value={plan.price ?? ''}
          onChange={e => handleChange('price', Number(e.target.value))}
          fullWidth
          margin="dense"
          required
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={plan.active !== undefined ? (plan.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Subscription Plan
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdSpaceSubscriptionPlansAdminAddSubscriptionPlanPage;